<template>
    <div class="time ml20 fs16 color_333 flex aic">{{text}}</div>
</template>

<script>
  import {timeFormat} from "../../lib/utils";

  export default {
    name: "header-time",
    data() {
      return {
        time: 0
      }
    },
    computed: {
      text() {
        return timeFormat(this.time, '%Y-%m-%d %H:%M:%S') + ' 星期' + timeFormat(this.time, '%W');
      }
    },
    created() {
      this.djs();
    },
    methods: {
      djs() {
        this.time = Date.now();
        setTimeout(this.djs, 1000);
      }
    },
  }
</script>

<style scoped>
    div {
        height: 70px;
    }
</style>
